import { useParams } from 'react-router';

export const useRouteParams = <ParamsT extends { [K in keyof ParamsT]?: string | undefined }>(
  encoded = false,
) => {
  const paramsMap = useParams<ParamsT>();
  if (encoded) {
    return paramsMap;
  }

  return Object.entries(paramsMap).reduce(
    (params, [key, value]) => ({
      ...params,
      [key]: decodeURIComponent(value as string),
    }),
    {} as ParamsT,
  );
};
